// @tennis-matches/core/ui-globals
// Global error overlay for debugging
// Used by all apps for consistent error display

let __installed = false;

/** Navigation / React-Strict-Mode / doppelte Requests: kein roter Vollbild-Fehler. */
function __isAbortLikeForOverlay(reason) {
  try {
    const r = reason;
    const name = String(r?.name || "").toLowerCase();
    const msg = String(r?.message || r || "").toLowerCase();
    const code = String(r?.code || "").toLowerCase();
    return (
      name === "aborterror" ||
      code === "auth_bootstrap_timeout" ||
      code === "supabase_init_getsession_timeout" ||
      msg.includes("operation was aborted") ||
      msg.includes("the user aborted") ||
      msg.includes("user aborted a request") ||
      msg.includes("aborterror") ||
      msg.includes("abgebrochen") ||
      msg.includes("load aborted") ||
      msg.includes("auth-bootstrap") ||
      msg.includes("getsession: abort retries exhausted")
    );
  } catch {
    return false;
  }
}

// Global Error Overlay (helps debug "problem on all pages")
export function installGlobalErrorOverlay() {
  if (__installed) return;
  __installed = true;

  let bar = null;

  const ensure = () => {
    if (bar) return bar;
    bar = document.createElement("div");
    bar.setAttribute("data-role", "globalErrorBar");
    bar.style.position = "fixed";
    bar.style.left = "12px";
    bar.style.right = "12px";
    bar.style.bottom = "12px";
    bar.style.zIndex = "99999";
    bar.style.display = "none";
    bar.style.padding = "10px 12px";
    bar.style.borderRadius = "10px";
    bar.style.border = "1px solid rgba(200,0,0,.35)";
    bar.style.background = "rgba(255,235,238,.98)";
    bar.style.color = "#8a1f1f";
    bar.style.fontFamily = "ui-sans-serif, system-ui, -apple-system";
    bar.style.fontSize = "14px";
    bar.style.boxShadow = "0 6px 24px rgba(0,0,0,.12)";
    bar.innerHTML = `
      <div style="display:flex; align-items:flex-start; gap:10px;">
        <div style="flex:1; min-width:0;">
          <div style="font-weight:700; margin-bottom:4px;">Fehler in der App</div>
          <pre data-role="globalErrorText" style="margin:0; white-space:pre-wrap; word-break:break-word;"></pre>
        </div>
        <button type="button" data-action="dismissGlobalError" style="border:0; background:transparent; font-size:18px; line-height:1; cursor:pointer; color:#8a1f1f;">×</button>
      </div>
    `;
    document.body.appendChild(bar);
    bar.addEventListener("click", (e) => {
      const btn = e.target?.closest?.('[data-action="dismissGlobalError"]');
      if (!btn) return;
      bar.style.display = "none";
    });
    return bar;
  };

  const show = (text) => {
    const el = ensure();
    const pre = el.querySelector('[data-role="globalErrorText"]');
    if (pre) pre.textContent = String(text || "").slice(0, 4000);
    el.style.display = "";
  };

  window.addEventListener("error", (ev) => {
    try {
      if (__isAbortLikeForOverlay(ev?.error)) return;
      const msg = ev?.error?.stack || ev?.error?.message || ev?.message || "Unbekannter Fehler";
      show(msg);
    } catch (_) {}
  });

  window.addEventListener("unhandledrejection", (ev) => {
    try {
      const r = ev?.reason;
      if (__isAbortLikeForOverlay(r)) {
        ev.preventDefault?.();
        return;
      }
      const msg = r?.stack || r?.message || String(r || "Unhandled rejection");
      show(msg);
    } catch (_) {}
  });
}
